import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueCookies from 'vue-cookies'
import Newsletter from './Newsletter.vue'
import './assets/styles/tailwind.css'

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(VueCookies)

new Vue({
  render: (h) => h(Newsletter)
}).$mount('#newsletter')
